import segmentConstants from '@/thirdPartyLibraries/segment/constants';
import { mapState } from 'vuex';

export default {
  data: () => ({
    segment: {
      constants: segmentConstants,
    },
  }),
  methods: {
    /**
    * Tracks form event swith our segment analytics. Accepts an event name and
    * a `properites` object. Adds default properties that should always be tracked
    * to that object.
    * @param event {string} Event name.
    * @param properties {Object} Properties to be tracked.
    * @param callback {function} Callback to be run after a short timeout.
    */
    trackEvent(event, properties = {}, callback) {
      const applicationId = this.$route?.params.applicationId;
      const updatedProperties = {
        ...properties,
        hasBypassCode: !!this.validationBypassCode,
        processStep: this.currentForm,
        processType: 'fast track 2.0',
        applicationId,
        cartId: this.trackingCartId,
        location: 'modal',
      };
      // Track if segment is initialized, otherwise just execute the callback.
      // Done this way so the callback can still be run when adblockers are used.
      if (window.analytics?.initialized) {
        window.analytics.track(event, updatedProperties, null, callback);
      } else if (callback) {
        callback();
      }
    },
    /**
    * Get current form name for segment tracking from constants.
    */
    getFormName() {
      const formNamesArr = Object.values(this.segment.constants.forms);
      return formNamesArr[this.currentFormIndex];
    },
    /**
    * Tracks an event for the current form. Puts together the full event string
    * and then calls segment tracking.
    * @param event {string} Event to be logged, ie: "Closed", "Opened", "Submitted", ect..
    * @param properties {Object} Optional properties to be passed into tracking.
    * @param callback {function} Optional callback to be executed by segment tracking.
    */
    trackCurrentFormEvent(event, ...args) {
      const formName = this.getFormName();
      this.trackEvent(`${formName} Form ${event}`, ...args);
    },
  },
  computed: {
    ...mapState('customerData', ['validationBypassCode', 'trackingCartId']),
    ...mapState('forms', ['currentForm', 'currentFormIndex']),
  },
};
